import { useMemo } from 'react';
export const useElementCallbacks = (headings, handleElementEvent) => {
  // Create element callbacks from unified handler
  return useMemo(() => ({
    onDropdownOpen: data => {
      const heading = headings[data.index];
      if (heading) {
        handleElementEvent('dropdownOpen', heading.elementId, heading.componentId, data.index, data.status);
      }
    },
    onElementApply: data => {
      const heading = headings[data.index];
      if (heading) {
        handleElementEvent('apply', heading.elementId, heading.componentId, data.index, data.status, {
          value: data.value
        });
      }
    },
    onElementCancel: data => {
      const heading = headings[data.index];
      if (heading) {
        handleElementEvent('cancel', heading.elementId, heading.componentId, data.index, data.status);
      }
    },
    onElementClick: data => {
      const heading = headings[data.index];
      if (heading) {
        handleElementEvent('click', heading.elementId, heading.componentId, data.index, data.status, {
          ctaName: data.ctaName
        });
      }
    },
    onElementStatusChange: data => {
      const heading = headings[data.index];
      if (heading) {
        handleElementEvent('statusChange', heading.elementId, heading.componentId, data.index, data.status, {
          value: data.value
        });
      }
    },
    onFieldChange: data => {
      const heading = headings[data.index];
      if (heading) {
        handleElementEvent('fieldChange', heading.elementId, heading.componentId, data.index, data.status, {
          fieldName: data.fieldName,
          value: data.value
        });
      }
    },
    onLearnMoreClick: data => {
      const heading = headings[data.index];
      if (heading) {
        handleElementEvent('learnMore', heading.elementId, heading.componentId, data.index, data.status);
      }
    }
  }), [headings, handleElementEvent]);
};
//# sourceMappingURL=hooks.js.map